/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface StageResponse {
  id: string;
  name: string;
  color: string;
  description?: string;
  position: number;
  is_system: boolean;
  candidate_count?: number;
  origin_ats_name?: string | null;
}
